import BuildabilitySwitcher from './BuildabilitySwitcher'
import enterVehicleCodeButtonContainer from './buildabilitySwitcherContainer'

export default enterVehicleCodeButtonContainer(BuildabilitySwitcher)
